import { useState, useEffect } from 'react';

const XS_BREAKPOINT = 480;

export function useMediaQuery() {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(min-width: ${XS_BREAKPOINT}px)`).matches;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${XS_BREAKPOINT}px)`);
    const handler = (event: MediaQueryListEvent) => setIsDesktop(event.matches);

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return {
    isMobile: !isDesktop,
    isDesktop,
  };
}
